import type { AnchorHTMLAttributes } from 'react';
import { Link, type LinkProps } from 'react-router-dom';
import styled from 'styled-components';

import { Icon } from '../../Icons';
import type { IconName } from '../../Icons/IconNames';
import { iconButtonStyles } from '../IconButton/styles';
import { buttonStyle, type ButtonProps } from '../styles';

export interface NavIconButtonWrapperProps
  extends
    Omit<ButtonProps<AnchorHTMLAttributes<HTMLAnchorElement>>, 'prefix' | 'suffix' | 'startIcon' | 'endIcon'>,
    Omit<LinkProps, 'to'> {
  /** If target is round or square */
  round?: boolean;
  to?: LinkProps['to'];
}

const nonForwardedProps = new Set(['ghost', 'round']);

export const NavIconButtonWrapper = styled(Link).withConfig({
  shouldForwardProp: (prop, defaultValidatorFn) => !nonForwardedProps.has(prop) && defaultValidatorFn(prop),
})<NavIconButtonWrapperProps>`
  text-decoration: none;

  ${({ theme, size, variant, disabled, ghost, dim, prominent }) =>
    buttonStyle({
      theme,
      size,
      variant,
      disabled,
      ghost,
      prominent,
      dim,
    })}

  ${iconButtonStyles}
`;

export interface NavIconButtonProps extends NavIconButtonWrapperProps {
  icon: IconName;
}

export const NavIconButton = styled(({ icon, variant, color, ghost, to, ...props }: NavIconButtonProps) => (
  <NavIconButtonWrapper
    to={props.disabled ? '#' : (to as string)}
    variant={ghost ? undefined : variant}
    ghost={ghost}
    {...props}
  >
    <Icon icon={icon} variant={ghost ? variant : undefined} color={color} />
  </NavIconButtonWrapper>
))``;
